export const tableauReportConstants = {
    // Tableau publishing
    PUBLISH_TABLEAU_DATA: 'PUBLISH_TABLEAU_DATA',
    GET_TABLEAU_PUBLISHING_CRON_MODE_STARTED: "GET_TABLEAU_PUBLISHING_CRON_MODE_STARTED",
    GET_TABLEAU_PUBLISHING_CRON_MODE_SUCCESS: "GET_TABLEAU_PUBLISHING_CRON_MODE_SUCCESS",
}

export default tableauReportConstants;